import { render, staticRenderFns } from "./ResourceBookingServiceList.vue?vue&type=template&id=78a95e70"
import script from "./ResourceBookingServiceList.vue?vue&type=script&lang=js"
export * from "./ResourceBookingServiceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports